import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function Privacy() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Header */}
      <div className="header">
        <img src="/logo.png" alt="Smart Parking Logo" className="logo" />
        <div className="heading-text">
          <br />
          <Typography variant="h4" className="title">
            Smart Parking App
          </Typography>
          <Typography variant="body2" className="caption">
            "Empowering Digital India .."
          </Typography>
        </div>
      </div>



      {/* Main Content */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 380,
          width: "87%",
          mx: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "medium", color: "#1565c0" }}
        >
          Privacy Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          At Smart Parking App, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our services.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We collect the minimum information necessary to provide our parking services:
          <ul>
            <li><strong>Vehicle Information:</strong> Your vehicle number to identify your vehicle for parking purposes.</li>
            <li><strong>Payment Information:</strong> Basic details such as name and contact information, as required by our payment provider, Razorpay, to process payments.</li>
          </ul>
          We do not collect or store any additional personal data beyond what is necessary.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          The information we collect is used solely for:
          <ul>
            <li>Facilitating parking services within the Kalimpong Municipality area.</li>
            <li>Processing payments securely through Razorpay.</li>
            <li>Ensuring compliance with applicable laws and regulations.</li>
          </ul>
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          3. Third-Party Services
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We use Razorpay, a third-party payment gateway, to process payments. Razorpay may collect additional information as per their privacy policy. We do not store any sensitive payment details, such as credit card numbers or bank account information, on our servers.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          4. Data Security
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          5. Data Retention
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We retain your information only for as long as necessary to provide our services and comply with legal obligations. Once no longer needed, your information is securely deleted.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          6. Your Rights
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          You have the right to:
          <ul>
            <li>Request access to the personal information we hold about you.</li>
            <li>Request correction or deletion of your information, subject to legal requirements.</li>
          </ul>
          To exercise these rights, please contact us using the details below.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          7. Changes to Privacy Policy
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page, and continued use of the app constitutes acceptance of the updated policy.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          8. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          For any questions or concerns regarding this Privacy Policy, please contact us at:
          <br />
          Email: <Link href="mailto:parkingsupport@apptech.co.in" sx={{ color: "#1565c0" }}>parkingsupport@apptech.co.in</Link>
          <br />
          Phone: <Link href="tel:+917001841402" sx={{ color: "#1565c0" }}>+91 7001841402</Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Privacy;